import { render, staticRenderFns } from "./PaymentsDropdown.vue?vue&type=template&id=87360728"
import script from "./PaymentsDropdown.vue?vue&type=script&lang=js"
export * from "./PaymentsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports